import { Outlet, Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import eventBus from './common/EventBus';
import CssLoader from './components/cssloader/CssLoader';
import { useEffect, useState } from 'react';
import ErrorHandler from './pages/Error/Error';
import { createRoutes, fetchMenuData, PrivateRoute, RouteItem } from './components/Router';
import Advertising from './common/Advertising';
import { MenuResponseJSON } from './helpers/interfaces';
import { MenuSingletonProvider } from './singleton/menuSingleton';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';
import 'font-awesome/css/font-awesome.min.css';
import './App.css'

export default function App() {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [loaderText, setLoaderText] = useState<string>('');
  const [routes, setRoutes] = useState<RouteItem[]>([]);
  const [menuJsonData, setMenuJsonData] = useState<MenuResponseJSON>({ data: [] })

  
  useEffect(() => {
    (async () => {

      const menuResponse = await fetch("https://www.calcioa5live.com/apiCA5L.php?op=menu");
      const menuJsonData: MenuResponseJSON = await menuResponse.json();
      const menuData = await fetchMenuData(menuJsonData);

      setMenuJsonData(menuJsonData);
      setRoutes(menuData);
    })();
  }, []);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        errorElement={<PrivateRoute
          id="error"
          isPrivate={false}
          element={<ErrorHandler />}
          menu={menuJsonData}
        />}
        element={<Outlet />}
      >
        {createRoutes(routes, menuJsonData)}
      </Route>
    )
  );

  function showLoaderAction(data: any) {
    setShowLoader(true);
    setLoaderText(data.detail.text);
  }

  function hideLoaderAction() { setShowLoader(false); }

  eventBus.on("showLoader", showLoaderAction);
  eventBus.on("hideLoader", hideLoaderAction);

  return <>
    <MenuSingletonProvider>
      <Advertising code="banner-background" type="background" />
      <div className="container-fluid p-0">
        {routes.length > 0 ? (
          <RouterProvider router={router} />
        ) : (
          <CssLoader active={true} text="Caricamento in corso..." />
        )}
        <CssLoader active={showLoader} text={loaderText} />
        <div id="script-container" />
      </div>
    </MenuSingletonProvider>
  </>;
}
